<div class='modal-backdrop'>
  <div class='modal-dialog'>
    <div class='modal-content'>
      <div class='modal-header'>
        <h4 class='modal-title'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.TITLE' | translate }}</h4>
      </div>
      <form [formGroup]='subscriptionChangeStatusFormGroup' (ngSubmit)='onSubmitSubscriptionStatusForm()' autocomplete='off' novalidate>
        <div class='form-horizontal form-label-left'>
          <div class='modal-body'>
            <div class='form-group'>

              <!-- TARGET STATUS -->
              <div class='form-group'>
                <label class='control-label col-sm-4 col-md-4 col-xs-4'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.TARGET_STATUS' | translate }}</label>
                <div class='col-sm-8 col-md-8 col-xs-8'>
                  <div class='select-row'>
                    <select class='form-control select-row' formControlName='targetStatus' id='targetStatus'>
                      @for (targetStatus of targetStatusList; track targetStatus) {
                        <option [ngValue]='targetStatus'>{{ 'STATUS.SUBSCRIPTION.' + targetStatus | translate }}</option>
                      }
                    </select>
                    <div class='remove-btn-placeholder'></div>
                  </div>
                </div>
              </div>

              <!-- APPLICATION DEFERRED OR NOT -->
              <div class='form-group'>
                <label class='control-label col-sm-4 col-md-4 col-xs-4'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.APPLICATION' | translate }}</label>
                <div class='col-sm-8 col-md-8 col-xs-8'>
                  <label class='control-label switch-choice'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.IMMEDIATE' | translate }}</label>
                  <ap-switch-toggle formControlName='isDeferred'></ap-switch-toggle>
                  <label class='control-label switch-choice'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.DIFFERED' | translate }}</label>
                </div>
              </div>

              <!-- EFFECTIVE DATE -->
              @if (isDeferred.value) {
                <div class='form-group'>
                  <label class='control-label col-sm-4 col-md-4 col-xs-4'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.EFFECTIVE_DATE' | translate }}*</label>
                  <div class='col-sm-8 col-md-8 col-xs-8 date-row'>
                    <input matInput class='form-control' [min]='minDate' formControlName='effectiveDate' id='subscriptionStatusPlannedDate' maxlength='10' autocomplete='off' [matDatepicker]='subscriptionStatusPlannedDate'/>
                    <mat-datepicker-toggle matSuffix [for]='subscriptionStatusPlannedDate' class='calendar-icon-toggle'></mat-datepicker-toggle>
                    <mat-datepicker #subscriptionStatusPlannedDate></mat-datepicker>
                    @if (effectiveDate.invalid && (effectiveDate.dirty || effectiveDate.touched)) {
                      <ul class='parsley-errors-list filled'>
                        @if (effectiveDate.errors.required) {
                          <li class='parsley-required'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.ERRORS.EFFECTIVE_DATE_REQUIRED' | translate }}</li>
                        }
                      </ul>
                    }
                  </div>
                </div>
              }

              <!-- VALIDATION REQUEST REASON STATUS -->
              <div class='form-group'>
                <label class='control-label col-sm-4 col-md-4 col-xs-4'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.CHANGE_STATUS.REASON_STATUS' | translate }}</label>
                <div class='col-sm-8 col-md-8 col-xs-8'>
                  <div formArrayName='reasons'>
                    @for (ctrl of reasons.controls; let i = $index; track i) {
                      <div class='reason-row'>
                        <input maxlength='255' type='text' id='reason-{{i}}' name='reason-{{i}}' class='form-control' [formControl]='ctrl' placeholder='Motif {{i+1}}'>
                        @if (i > 0) {
                          <button class='btn btn-xs btn-danger remove-btn' type='button' (click)='removeRaison(i)'><i class='fa fa-trash'></i></button>
                        } @else if (reasons.length < maxReasons) {
                          <button class='btn btn-xs btn-info add-btn' id='add-reason' name='add-reason' type='button' (click)='addRaison()'><i class='fa fa-plus'></i></button>
                        } @else {
                          <div class='remove-btn-placeholder'></div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class='modal-footer'>
            <button type='submit' [disabled]='subscriptionChangeStatusFormGroup.invalid' class='btn btn-success pull-right'>{{ 'ACTIONS.CONFIRM' | translate }}</button>
            <button type='button' class='btn btn-danger pull-right' (click)='cancel()'>{{ 'ACTIONS.CANCEL' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
